export default class IncompleteFormError extends Error {
	constructor() {
		super("Please complete all required fields.");
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
